export const colors = [
  "#69C24A",
  "#FD8087",
  "#9869FE",
  "#4292FD",
  "#1A509A",
  "#FF9A48",
  "#FFC34F",
];